
interface PostContentProps {
  content: string;
}

export default function PostContent({ content }: PostContentProps) {
  return (
    <article
      className="prose prose-lg max-w-none
        prose-headings:font-serif prose-headings:text-gray-900 prose-headings:tracking-wide
        prose-h3:text-xl prose-h3:mt-10 prose-h3:mb-4
        prose-p:text-gray-600 prose-p:text-[15px] prose-p:leading-[1.85]
        prose-strong:text-gray-800
        prose-a:text-[#2E7D32] prose-a:no-underline hover:prose-a:underline"
      dangerouslySetInnerHTML={{ __html: content }}
    />
  );
}
